export default class WebsocketConnectionTimeoutError extends Error {
  constructor() {
    super("Websocket connection timeout");
  }
}
